import '@/index.css';
import '@/federation/runtime';
import { initDatadogRum, trackPerformance } from '@/lib/datadog';
import { initWebVitals } from '@/lib/perf/web-vitals';
import { initPerfObservers } from '@/lib/perf/observers';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/app';

// Inicializa serviços de monitoramento e analytics
initDatadogRum();
initWebVitals();
initPerfObservers();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

performance.mark('shell:react-render-called');
const bootMeasure = performance.measure(
  'react.boot.duration',
  'shell:script-start',
  'shell:react-render-called'
);
trackPerformance('react_boot', bootMeasure.duration, { category: 'shell' });
